
import { Stack, } from '@mui/material';
import ListSets from './SetsPage';
import ListFolders from './FoldersPage';

const LatestPage = () => {
    return (
        <Stack
            direction='column'
            spacing={{
                xs: 6,
                sm: 7,
                md: 8,
                lg: 9,
            }}>
            <ListSets />
            <ListFolders />
        </Stack>
    )
};

export default LatestPage;